import { Component, OnInit, Input, HostListener } from "@angular/core";
import { ProductDetails } from "../../shared/interface/product-details";
import { ProductCompare } from "../../shared/interface/product-compare";
import { LayoutService } from "../../shared/service/layout.service";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import * as reducers from "../../reducers";

@Component({
  selector: "suggested-product",
  template: `
    <div class="total-products-text" *ngIf="totalProducts < 1">
      <div *ngIf="productSearchTerm && locale !== 'ru-ru'">
        {{ totalProducts }}
        {{ "search_results_found" | translate | lowercase }} '<b>{{
          productSearchTerm
        }}</b
        >'
      </div>
      <div *ngIf="productSearchTerm && locale === 'ru-ru'">
        {{ "search_results_found_part1" | translate | lowercase }} '<b>{{
          productSearchTerm
        }}</b
        >' {{ "search_results_found_part2" | translate | lowercase }}:
        {{ totalProducts }}
      </div>
      <div
        *ngIf="
          !productSearchTerm && !suggestedProduct.length && locale !== 'ru-ru'
        "
        style="padding-bottom: 30px; font-weight: bold;"
      >
        {{ totalProducts }} {{ "filter_results_found" | translate | lowercase }}
      </div>
      <div
        *ngIf="
          !productSearchTerm && !suggestedProduct.length && locale === 'ru-ru'
        "
        style="padding-bottom: 30px; font-weight: bold;"
      >
        {{ "filter_results_found" | translate | lowercase }} {{ totalProducts }}
      </div>
    </div>
    <div class="total-products-text" *ngIf="totalProducts > 0">
      <div *ngIf="productSearchTerm && locale !== 'ru-ru'">
        {{ totalProducts }}
        {{ "search_results_found" | translate | lowercase }} '<b>{{
          productSearchTerm
        }}</b
        >'
      </div>
      <div *ngIf="productSearchTerm && locale === 'ru-ru'">
        {{ "search_results_found_part1" | translate | lowercase }} '<b>{{
          productSearchTerm
        }}</b
        >' {{ "search_results_found_part2" | translate | lowercase }}:
        {{ totalProducts }}
      </div>
      <div
        *ngIf="
          !productSearchTerm && !suggestedProduct.length && locale !== 'ru-ru'
        "
        style="padding-bottom: 30px; font-weight: bold;"
      >
        {{ totalProducts }} {{ "filter_results_found" | translate | lowercase }}
      </div>
      <div
        *ngIf="
          !productSearchTerm && !suggestedProduct.length && locale === 'ru-ru'
        "
        style="padding-bottom: 30px; font-weight: bold;"
      >
        {{ "filter_results_found" | translate | lowercase }} {{ totalProducts }}
      </div>
    </div>

    <div *ngIf="suggestedProduct.productDetails?.length > 0">
      <div *ngIf="productSearchTerm !== ''" class="suggested-product-text">
        {{ "error_search" | translate }}
        <span class="search-term">'{{ productSearchTerm }}'</span>
        <span *ngIf="locale === 'de-de'">
          {{ "error_search_after" | translate }}
        </span>
        <div style="padding-top: 30px;">
          {{ "error_search_suggest" | translate }}
        </div>
      </div>
      <div *ngIf="productSearchTerm === ''">
        <div class="suggested-product-text">
          {{ suggestedProduct.totalProducts }} {{ "error_filter" | translate }}
        </div>
      </div>
    </div>
    <!-- div *ngIf="suggestedProduct.productDetails?.length > 0">
		<div>
			<div class="suggested-product-text"> {{suggestedProduct.totalProducts}} {{ 'error_filter' | translate }}</div>
		</div>
  </div -->
  `,
  styles: [
    `
      .suggested-product-text {
        font-size: 18px;
        padding-top: 30px;
      }
      .total-products-text {
        font-size: 16px;
        padding-top: 30px;
      }
      .search-term {
        /*font-size: 16px;
		line-height: 24px;*/
        color: #333;
        font-weight: bold;
      }
    `,
  ],
})
export class SuggestedProductComponent implements OnInit {
  @Input() screenWidth: string;
  @Input() suggestedProduct;
  @Input() totalProducts;
  @Input() productSearchTerm;
  productDetail;
  locale: string;

  constructor() {}

  ngOnInit() {
    var that = this;
    let locale = window.location.pathname.split("/")[1];
    this.locale = locale;
  }
}
